// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/no-unused-prop-types, react/destructuring-assignment */
import * as React from "react"
import { connect } from "react-redux"
import classnames from "classnames"
// @ts-expect-error: Flow to TS migration.
import type { Route } from "react-router-config"
import CookiesPopup from "@kiwicom/nitro/lib/components/CookiesPopup"
import { useAuth } from "@kiwicom/nitro/lib/services/auth/context"
import { useFeature } from "@kiwicom/darwin"
import { topic } from "@kiwicom/frontend-mmb/services/tracking/businessEvents"

import Notice from "../Notice/Notice"
import MoveToBody from "../MoveToBody/MoveToBody"
import MobileAd from "../MobileAd/MobileAd"
import UpdateRoute from "../UpdateRoute/UpdateRoute"
import { isKiwiBrandingSelector } from "../../services/branding/selectors"
import MaintenanceModal from "../MaintenanceModal/MaintenanceModal"
import SmartFAQ from "../../modules/SmartFAQ"
import NitroSideEffects from "../NitroSideEffects"
import type SearchFormState from "../../records/SearchFormState"
import { showModal } from "../../services/modals/actions"
import useIsMobileApp from "@kiwicom/frontend-mmb/scenes/AccountBooking/components/Booking/scenes/MmbOverview/futureMigration/useIsMobileApp"
import useSSRFlags from "@kiwicom/frontend-mmb/scenes/AccountBooking/components/Booking/scenes/MmbOverview/futureMigration/useSSRFlags"
import { NavBar } from "./MainView.styled"
import MagicLoginModal from "../../modules/MagicLogin"

const isHelpCenter = (pageName?: string | null) =>
  pageName ? pageName.includes("helpCenter") : false

type Connect = {
  pageName: string
  isKiwiBranding: boolean
  maintenance: boolean
  showModal: (
    modal: string,
    obj: {
      activeTab: string
    },
  ) => void
  searchForm: SearchFormState
}

type Props = Connect & {
  module: "mmb" | "notFound"
  query: {
    deeplink: string
  }
  routes?: Route[]
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  params?: {
    [key: string]: string | null | undefined
  }
  children: React.ReactNode
  navbar: React.ReactNode
}

const MainView = (props: Props) => {
  const { modal } = useAuth()
  const shouldShowRejectAllButton = useFeature("COOKIE_CONSENT_REJECTALL")
  const isMobileApp = useIsMobileApp()
  const { isTequila } = useSSRFlags()

  return (
    <UpdateRoute routes={props.routes} params={props.params} query={props.query}>
      <NitroSideEffects />
      {!isMobileApp && !isTequila && (
        <NavBar>
          <nav className="NitroNavBar">{props.navbar}</nav>
        </NavBar>
      )}
      <div
        className={classnames("MainView", {
          loginOpened: modal != null,
        })}
      >
        {props.isKiwiBranding && <MobileAd />}
        {props.maintenance && !isHelpCenter(props.pageName) ? <MaintenanceModal /> : props.children}
        <SmartFAQ />
      </div>
      <Notice />
      <MagicLoginModal />
      {!isMobileApp && !isTequila && (
        <MoveToBody>
          <CookiesPopup
            pubSubTopic={topic}
            showRejectAll={shouldShowRejectAllButton}
            disableAnimation
          />
        </MoveToBody>
      )}
    </UpdateRoute>
  )
}

export default connect(
  (state) => ({
    // @ts-expect-error: Flow to TS migration.
    pageName: state.page.get("name"),
    // @ts-expect-error: Flow to TS migration.
    maintenance: Boolean(state.modals.get("maintenance")),
    isKiwiBranding: isKiwiBrandingSelector(state),
  }),
  {
    showModal,
  },
  // @ts-expect-error: Flow to TS migration.
)(MainView)
